// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import SeoLogoIco from '../../../../Library/SEO/SeoLogoIco';
import SeoMetaDescription from '../../../../Library/SEO/SeoMetaDescription';
import SeoMetaKeywords from '../../../../Library/SEO/SeoMetaKeywords';
import SeoMetaTitle from '../../../../Library/SEO/SeoMetaTitle';
// ##### Komarov 2025-07-24
import HeaderClassDiv from './HeaderClassDiv';
import MiddleMenuDiv from './MiddleMenuDiv';
// ##### 25-04-23 Komarov
import { useDispatch, useSelector } from 'react-redux';
import { selectDeviceType } from '../../../../../Redux/selectors';
import { getLoadedPage } from '../../../../../Redux/actions';
// ##### 25-04-29 Komarov
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-14
const HeaderWrapperMain = () => {
  // ##### 2025-09-11 Komarov
  const hotelcontent = useSelector(state => state.hotelcontent.hotelcontent);
  // ##### 25-04-29 Komarov
  const location = useLocation();
  const browserUrl = `${location.pathname}${location.search}`.substring(3);
  // ##### Komarov 2025-07-21
  const urlToObject = useValidateQuery();
  // ##### 24-08-22 Komarov: 209 - главная страница без id в URL
  const page_id_from_url = urlToObject?.id ? urlToObject.id : 209;
  const dispatch = useDispatch();
  const language = useSelector(state => state.language);
  const loadedpages = useSelector(state => state.pages.loadedpages);
  const deviceType = useSelector(selectDeviceType);

  // ##### Komarov 2025-07-28
  useEffect(() => {
    if (!loadedpages[page_id_from_url]?.[language]) {
      dispatch(
        getLoadedPage({ spid: page_id_from_url, deviceType, lang: language })
      );
    }
  }, [page_id_from_url, deviceType, language]);

  // ##### Komarov 2025-07-28
  useEffect(() => {
    if (!loadedpages[221]?.[language]) {
      dispatch(getLoadedPage({ spid: 221, deviceType, lang: language }));
    }
    if (!loadedpages[304]?.[language]) {
      dispatch(getLoadedPage({ spid: 304, deviceType, lang: language }));
    }
    if (!loadedpages[305]?.[language]) {
      dispatch(getLoadedPage({ spid: 305, deviceType, lang: language }));
    }
  }, [deviceType, language]);

  const purePageSsr = loadedpages[page_id_from_url]?.[language];

  const currentPurePage =
    ((browserUrl.includes('hotel_details') ||
      browserUrl.includes('hotel_overview')) &&
      hotelcontent) ||
    (((urlToObject && !urlToObject?.id) ||
      (browserUrl.includes('sitepages') &&
        ['spid=2', 'spid=210'].includes(`spid=${urlToObject?.spid}`))) &&
      purePageSsr);

  const metaTitleObject =
    currentPurePage &&
    currentPurePage.length > 0 &&
    currentPurePage.find(item => item.content_name === 'Meta-Title');
  const metaTitleObjectText = metaTitleObject?.text;

  const metaKeywordsObject =
    currentPurePage &&
    currentPurePage.length > 0 &&
    currentPurePage.find(item => item.content_name === 'Meta-Keywords');
  const metaKeywordsText = metaKeywordsObject?.text;

  const metaDescriptionObject =
    currentPurePage &&
    currentPurePage.length > 0 &&
    currentPurePage.find(item => item.content_name === 'Meta-Description');
  const metaDescriptionText = metaDescriptionObject?.text;

  // ##### Komarov 2025-07-28
  return (
    <header className="wrapperMain" data-component="HeaderWrapperMain">
      <SeoLogoIco />
      {((loadedpages[page_id_from_url]?.[language] && metaTitleObjectText) ||
        loadedpages[221]?.[language]?.[0]?.text) && (
          <SeoMetaTitle
            metaTitleObjectText={
              metaTitleObjectText || loadedpages[221][language][0].text
            }
          />
        )}
      {((loadedpages[page_id_from_url]?.[language] && metaKeywordsText) ||
        loadedpages[304]?.[language]?.[0]?.text) && (
          <SeoMetaKeywords
            metaKeywordsText={
              metaKeywordsText || loadedpages[304][language][0].text
            }
          />
        )}
      {((loadedpages[page_id_from_url]?.[language] && metaDescriptionText) ||
        loadedpages[305]?.[language]?.[0]?.text) && (
          <SeoMetaDescription
            metaDescriptionText={
              metaDescriptionText || loadedpages[305][language][0].text
            }
          />
        )}
      {/* ##### 23-10-31 Komarov */}
      <Media lessThan="Laptop-1024-1440">
        <HeaderClassDiv headerClass="topMenuTabletPortrait" />
      </Media>
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <HeaderClassDiv headerClass="topMenu" />
      </Media>
      {/* ##### 23-10-31 Komarov */}
      <Media lessThan="Mobile-S-320-375">
        <MiddleMenuDiv
          // ##### 23-10-31 Komarov
          className="middleMenuSmallScreen middleMenuSmallScreenLandscapeMobile"
          logoWidth="25.5vw"
        />
      </Media>
      {/* ##### 23-10-31 Komarov */}
      <Media at="Mobile-S-320-375">
        <MiddleMenuDiv
          className="middleMenuSmallScreen middleMenuSmallScreenLandscapeMobile"
          logoWidth="19.5vw"
        />
      </Media>
      {/* ##### 23-10-31 Komarov */}
      <Media at="Mobile-M-375-425">
        <MiddleMenuDiv
          className="middleMenuSmallScreen middleMenuSmallScreenLandscapeMobile"
          logoWidth="19.5vw"
        />
      </Media>
      <Media at="Mobile-L-425-768">
        <MiddleMenuDiv
          className="middleMenuSmallScreen middleMenuSmallScreenLandscapeMobile"
          logoWidth="15vw"
        />
      </Media>
      {/* ##### 23-10-31 Komarov */}
      <Media at="Tablet-768-1024">
        <MiddleMenuDiv className="middleMenuSmallScreen" logoWidth="14.5vw" />
      </Media>
      {/* ##### 23-10-31 Komarov */}
      <Media at="Laptop-1024-1440">
        <MiddleMenuDiv className="middleMenu" logoWidth="13.5vw" />
      </Media>
      {/* ##### 23-10-31 Komarov */}
      <Media greaterThanOrEqual="Laptop-L-1440-2560">
        <MiddleMenuDiv className="middleMenu" logoWidth="13.5vw" />
      </Media>
      { /* ##### Komarov 2025-07-24 */}
    </header>
  );
};

export default HeaderWrapperMain;
